module.exports = __webpack_public_path__ + "static/media/adelphi.9628ea8b.svg";